import Nullstack from 'nullstack';
export default function IconAtom2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-atom-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "21",
    x2: "12",
    y2: "21.01"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "9",
    x2: "3",
    y2: "9.01"
  }), "   ", Nullstack.element("line", {
    x1: "21",
    y1: "9",
    x2: "21",
    y2: "9.01"
  }), "   ", Nullstack.element("path", {
    d: "M8 20.1a9 9 0 0 1 -5 -7.1"
  }), "   ", Nullstack.element("path", {
    d: "M16 20.1a9 9 0 0 0 5 -7.1"
  }), "   ", Nullstack.element("path", {
    d: "M6.2 5a9 9 0 0 1 11.4 0"
  }), " ");
}